/* ======================================================================
   MF SHIPPING SYNC (2026-05-31) — Variante A: unsichtbarer Hintergrund-Sync
   ----------------------------------------------------------------------
   Der Server rendert die Versandkosten SOFORT aus der Länder-Tabelle
   (mf-shipping-cost.liquid) = Kaltstart, kein "wird berechnet".
   Dieses Script holt im HINTERGRUND die ECHTE Rate von Shopify
   (/cart/shipping_rates.json) für das Land des Besuchers, gleicht die
   Anzeige still ab und cached sie (localStorage).

   Eigenschaften (perf-schonend):
   - läuft NUR bei Warenkorb-Ansicht (Drawer-Open / Cart-Page / cart:change)
   - same-origin, nicht-blockierend, gecacht, kein Spinner
   - überschreibt NIE Gold ("Gratis · Gold-Mitglied")
   - kein Layout-Shift: Text wird nur getauscht, wenn er sich ändert
   - bei Fehler/Timeout/Rate-Limit: serverseitiger Wert bleibt stehen
   ====================================================================== */
(function () {
  if (window.__mfShipSync) return;
  window.__mfShipSync = true;

  var CACHE_KEY = 'mf_ship_rate_v1';
  var ZIPS = { DE: '10115', AT: '1010', CH: '8001', NL: '1011', FR: '75001', BE: '1000', LU: '1009', IT: '00118', ES: '28001', DK: '1050', SE: '11120', PL: '00-001', CZ: '11000' };

  function country() { return (window.Shopify && window.Shopify.country) || 'DE'; }

  function fmtEUR(n) {
    try { return n.toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €'; }
    catch (e) { return n.toFixed(2).replace('.', ',') + ' €'; }
  }
  function readCache() { try { return JSON.parse(localStorage.getItem(CACHE_KEY) || '{}'); } catch (e) { return {}; } }
  function writeCache(o) { try { localStorage.setItem(CACHE_KEY, JSON.stringify(o)); } catch (e) {} }

  function apply(cheapest) {
    var isFree = cheapest === 0;
    var text = isFree ? 'Gratis' : fmtEUR(cheapest);
    var rows = document.querySelectorAll('[data-mf-ship-row]');
    for (var i = 0; i < rows.length; i++) {
      var row = rows[i];
      if (row.getAttribute('data-mf-ship-gold') === '1') continue; // Gold nie anfassen
      var val = row.querySelector('[data-mf-ship-value]');
      if (!val) continue;
      var current = (val.textContent || '').replace(/\s+/g, ' ').trim();
      if (current === text) continue; // kein Reflow, wenn unverändert
      val.textContent = text;
      if (isFree) { row.classList.add('is-free'); } else { row.classList.remove('is-free'); }
    }
  }

  // Versandschwelle 0 (2026-09-23, Black Week): Die Leiter markiert sich mit
  // data-free-shipping-all="1". /cart/shipping_rates.json kennt keine
  // Versandrabatte und wuerde die Basisrate zeigen — dann bleibt DE auf "Gratis".
  function freeAllDE() {
    return country() === 'DE' && !!document.querySelector('cart-gift-tiers[data-free-shipping-all="1"]');
  }

  var inflight = false;
  function sync() {
    if (freeAllDE()) { apply(0); return; }
    if (inflight) return;
    inflight = true;
    var done = function () { inflight = false; };
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!cart || !cart.item_count) { done(); return; }
        var c = country();
        var sig = c + ':' + cart.total_price;
        var cache = readCache();
        if (typeof cache[sig] === 'number') apply(cache[sig]); // sofort aus Cache
        var zip = ZIPS[c];
        var url = '/cart/shipping_rates.json?shipping_address[country]=' + encodeURIComponent(c) + (zip ? ('&shipping_address[zip]=' + encodeURIComponent(zip)) : '');
        fetch(url, { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (j) {
            var rates = (j.shipping_rates || []).map(function (x) { return parseFloat(x.price); }).filter(function (x) { return !isNaN(x); });
            if (!rates.length) { done(); return; }
            var cheapest = Math.min.apply(null, rates);
            cache[sig] = cheapest; writeCache(cache);
            apply(cheapest);
            done();
          })
          .catch(done);
      })
      .catch(done);
  }

  function later() { setTimeout(sync, 300); } // nach Server-Re-Render abgleichen

  ['cart:change', 'cart:refresh', 'cart:updated', 'cart-drawer:open', 'dialog:open'].forEach(function (ev) {
    document.addEventListener(ev, later);
  });
  // Öffnen des Cart-Drawers (Toggle-Klick) abfangen
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('[aria-controls="cart-drawer"]')) later();
  }, true);
  // Cart-Page direkt beim Laden
  if (location.pathname.indexOf('/cart') === 0) {
    if (document.readyState !== 'loading') sync();
    else document.addEventListener('DOMContentLoaded', sync);
  }
})();
